import React from "react";
import { Brand } from "@/components/Brand";

/**
 * Short, honest privacy note for AdSense / cookie disclosure.
 * Not a full legal document — update if you add analytics or accounts beyond Sleeper.
 */
export function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-page">
      <header className="border-b border-[#0A0A0A]">
        <div className="max-w-3xl mx-auto px-6 lg:px-12 py-6 flex items-center justify-between gap-4">
          <a href="/" className="hover:opacity-80 transition-opacity" aria-label="TRYSTOMATIC home">
            <Brand size="md" />
          </a>
          <div className="flex items-center gap-4 text-xs uppercase tracking-[0.2em] font-mono-data text-[#52525B]">
            <a href="/about" className="hover:text-[#7C3AED] transition-colors">
              About
            </a>
            <a href="/support" className="hover:text-[#7C3AED] transition-colors">
              Support
            </a>
            <a href="/" className="hover:text-[#7C3AED] transition-colors">
              Home
            </a>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 lg:px-12 py-12">
        <p className="label-eyebrow">Legal</p>
        <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tighter mt-1">
          Privacy
        </h1>
        <p className="text-sm text-[#52525B] mt-3 max-w-prose leading-relaxed">
          TRYSTOMATIC is a dynasty fantasy football tool. This page explains what we collect and how ads work when enabled.
        </p>

        <section className="mt-10 space-y-8 text-sm text-[#3F3F46] leading-relaxed">
          <div>
            <h2 className="font-display font-bold text-lg tracking-tight text-[#0A0A0A]">What we use</h2>
            <p className="mt-2">
              If you sign in with Sleeper, we read your public Sleeper profile, leagues, and rosters to power the calculator and related tools. We do not ask for your Sleeper password.
            </p>
            <p className="mt-2">
              Guest and local preferences (for example selected league or open tool) may be stored in your browser via localStorage / sessionStorage.
            </p>
          </div>

          <div>
            <h2 className="font-display font-bold text-lg tracking-tight text-[#0A0A0A]">Advertising</h2>
            <p className="mt-2">
              When ads are configured for this site, we may show manual display ads via Google AdSense. Those ads can use cookies or similar technologies on your device to show relevant advertising and measure performance.
            </p>
            <p className="mt-2">
              Ads are optional for the product: if AdSense is not configured, no ad script loads and no ad slots render.
            </p>
            <p className="mt-2">
              Learn more from Google:{" "}
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#7C3AED] hover:underline"
              >
                Google Privacy Policy
              </a>
              {" · "}
              <a
                href="https://policies.google.com/technologies/ads"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#7C3AED] hover:underline"
              >
                How Google uses information from sites that use our services
              </a>
              {" · "}
              <a
                href="https://adssettings.google.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#7C3AED] hover:underline"
              >
                Ad Settings
              </a>
              .
            </p>
          </div>

          <div>
            <h2 className="font-display font-bold text-lg tracking-tight text-[#0A0A0A]">Contact</h2>
            <p className="mt-2">
              Questions about this site? See{" "}
              <a href="/about" className="text-[#7C3AED] hover:underline">
                About
              </a>{" "}
              for how to reach the maintainer.
            </p>
          </div>
        </section>
      </main>

      <footer className="border-t border-[#0A0A0A] mt-8">
        <div className="max-w-3xl mx-auto px-6 lg:px-12 py-8 text-xs text-[#52525B] font-mono-data flex flex-wrap items-center justify-between gap-2">
          <span>TRYSTOMATIC · Privacy · {new Date().getFullYear()}</span>
          <span className="flex items-center gap-3">
            <a href="/about" className="hover:text-[#7C3AED] transition-colors">
              About
            </a>
            <a href="/support" className="hover:text-[#7C3AED] transition-colors">
              Support
            </a>
          </span>
        </div>
      </footer>
    </div>
  );
}
